export function formatDate(date: Date, opts?: Intl.DateTimeFormatOptions) {
  return new Intl.DateTimeFormat("ru-RU", {
    month: "long",
    day: "numeric",
    // year: date.getFullYear() > new Date().getFullYear() ? "numeric" : undefined,
    ...opts,
  }).format(date);
}
